// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9a53a2b9","879":"0d24d786"}[chunkId] + ".chunk.js";
};